import React from 'react';
import ExchangeHistory from '../../../components/client/ExchangeHistory';

const ExchangeHistoryPage = () => {
    return <ExchangeHistory />;
};

export default ExchangeHistoryPage;
